import React from 'react';
import { Alert } from '../alert/Alert';
const FormFeedback = ({ message, className, iconPath, isShow, iconPosition, onClick, type, }) => {
    if (isShow) {
        return (React.createElement("div", { className: className },
            React.createElement(Alert, { onClick: onClick, message: message, color: type, iconPath: iconPath ? iconPath : undefined, iconPosition: iconPosition ? iconPosition : 'start' })));
    }
    else {
        return React.createElement(React.Fragment, null);
    }
};
export { FormFeedback };
//# sourceMappingURL=FormFeedback.js.map